import {Injectable} from '@angular/core';
import {BehaviorSubject} from "rxjs";
import {TheOfferPriceCurveData} from "../model/TheOfferPriceCurveData";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {LoadingController} from "@ionic/angular";
import {TheOfferPriceCurveDataTransfer} from "../model/TheOfferPriceCurveDataTransfer";
import {ForwardExportResult} from "../model/ForwardExportResult";
import {AlertService} from "./alert/alert.service";
import {I18nService} from "@astron/i18n";
import {saveAs} from 'file-saver';

@Injectable({
    providedIn: 'root'
})
export class TheOfferPriceCurveService {

    lastRefresh = new BehaviorSubject<Date>(new Date());

    priceData = new BehaviorSubject<TheOfferPriceCurveData[]>(undefined);

    months = new BehaviorSubject<Date[]>(undefined);

    intervalId;

    constructor(private http: HttpClient,
                private alertService: AlertService,
                private i18n: I18nService,
                private loadingController: LoadingController) {

    }


    ngOnInit() {

    }

    ngOnDestroy() {
        this.stopRefresh()
    }

    stopRefresh() {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
    }


    updateData() {

        const url = environment.backendURL + '/the-offer-price-curve';
        this.http.get<TheOfferPriceCurveDataTransfer>(url).subscribe(data => {
            if (data) {
                this.priceData.next(data.data || []);
                this.lastRefresh.next(this.getDate(data.lastRefresh));
                this.setMonths(data);

                // automatikus frissítés beállítása
                if (this.intervalId) {
                    this.stopRefresh()
                }
                let refreshFrequency;
                if (data.refreshFrequencyInSeconds) {
                    refreshFrequency = data.refreshFrequencyInSeconds * 1000;
                } else {
                    refreshFrequency = 60 * 1000;
                }
                this.intervalId = setInterval(() => {
                    this.updateData()
                }, refreshFrequency);

            } else {
                this.priceData.next([]);
                this.months.next([])
                this.lastRefresh.next(null);
            }
        });
    }

    private getDate(date: number) {
        return date ? new Date(date) : null;
    }

    private setMonths({firstMonth, lastMonth}: TheOfferPriceCurveDataTransfer) {
        const months: Date[] = [];

        let longDate = firstMonth;
        while (longDate <= lastMonth) {
            const date = new Date(longDate);
            months.push(date);
            longDate = new Date(date.getFullYear(), date.getMonth() + 1).getTime();
        }

        this.months.next(months);
    }

    sendEmail() {
        this.http.post<ForwardExportResult>(environment.backendURL + '/the-offer-price-curve/export/email', this.i18n.locale).subscribe(value => {
            const alertHeader = value === ForwardExportResult.SUCCESS ? 'alert_success' : 'alert_error';
            this.alertService.showAlertWithHeader(alertHeader, 'TheOfferPriceCurveExportResult_' + value);
        });
    }

    download() {
        this.loadingController.create({message: this.i18n.translate('alert_downloading')}).then(loading => {
            loading.present();
            this.http.post(environment.backendURL + '/the-offer-price-curve/export/download', this.i18n.locale, {
                responseType: 'arraybuffer',
                observe: 'response'
            }).subscribe(response => {
                const file = new Blob([response.body], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
                const fileName = response.headers.get('Content-Disposition').split('=')[1].split('"')[1];
                saveAs(file, fileName);
            }).add(() => loading.dismiss());
        });
    }
}
